import { IRootState } from '../../../../../store'
import { IPediatricTraumaScoreState } from '../store/pediatricTraumaScore.types'

export const getPediatricTraumaScoreSelector = (state: IRootState): IPediatricTraumaScoreState =>
  state.pediatricTraumaScore
